import { errorLogHandler } from '@shared/errorLogHandler';

interface ConvertBase64Result {
  url: string;
  width: number;
  height: number;
}
export const convertBase64 = (file: File) => {
  return new Promise<ConvertBase64Result>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      if (typeof fileReader.result !== 'string') {
        return;
      }

      const url = fileReader.result;
      const img = new Image();
      img.src = url;

      img.onload = () => {
        resolve({
          url,
          height: img.height,
          width: img.width,
        });
      };

      img.onerror = error => {
        reject(error);
      };
    };

    fileReader.onerror = error => {
      reject(error);
    };
  });
};

export const getUrlFromFile = async (file: File) => {
  try {
    const { url } = await convertBase64(file);

    return url;
  } catch {
    errorLogHandler('Failed to retrieve url from File');
  }
};
